<template>
  <v-container
    fluid
    grid-list-lg
    class="pa-0"
  >
    <v-slide-y-transition mode="out-in">
      <dx-scheduler :views="['day', 'week', 'month']" :startDayHour="7" :endDayHour="22"
                    :editing="false" :currentDate="currentDate.toDate()"
                    height="calc(100vh - 51px)" :dataSource="appointments"
                    @appointmentClick="appointmentClick" @appointmentDblClick="appointmentClick"
                    @optionChanged="optionChanged"
      >
        <!--<div slot="appointmentTooltip" slot-scope="data">-->
        <!--</div>-->
      </dx-scheduler>
    </v-slide-y-transition>

    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card v-if="selectedAppointment">
        <v-card-text>
          <strong><div v-if="selectedAppointment.data.Type">{{selectedAppointment.data.Type}} Appointment</div></strong>
          <div v-if="selectedAppointment.data.Address">{{selectedAppointment.data.Address}}</div>
          <div v-if="selectedAppointment.data.Details">{{selectedAppointment.data.Details}}</div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Close
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            v-if="selectedAppointment.data.Type && selectedAppointment.data.Type.indexOf('Viewing') !== -1"
            color="green darken-1"
            flat="flat"
            @click="openAppointment(selectedAppointment)"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import {mapActions} from 'vuex';
  import { DxButton, DxScheduler } from "devextreme-vue";

  export default {
    computed: {
      ...mapGetters(["appointments", "currentDate","allTenants"])
    },
    components: {
      DxButton, DxScheduler
    },
    data () {
      return {
        selectedAppointment: null,
        initialDate: new Date(),
        dialog: false
      };
    },
    methods: {
      openAppointment (appointment) {
        this.dialog = false;
        this.$router.push(`/appointments/${appointment.id}`);
      },
      appointmentClick (e) {
        e.cancel = true;
        this.$store.dispatch('setCurrentDate', e.appointmentData.startDate);
        this.selectedAppointment = e.appointmentData;
        this.dialog = true;
        setTimeout(() => {
          e.component.scrollToTime(e.appointmentData.startDate.hour(), e.appointmentData.startDate.minute())
        }, 50)
      },
      optionChanged (e) {
        if (e.fullName == 'views') {
          setTimeout(() => {
            e.component.scrollToTime(this.currentDate.hour(), this.currentDate.minute(), this.currentDate.toDate())
          }, 50)
        }

      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.$store.dispatch("loadAppointments");
      });
    }
  };
</script>

<style scoped>
</style>
